// extracted by mini-css-extract-plugin
export default {"header":"card_header___header___f30b1c0a","title":"card_header___title___cf190650","action":"card_header___action___a0dae279"};